<template>
  <v-row>
    <dialog-shipment-information
      v-model="selectedShipmentId"
      :dialog="dialogShipmentInformation"
      :tab="selectedTab"
      v-on:dialog-close="onDialogClose"
      v-on:shipment-deleted="onShipmentDeleted"
    ></dialog-shipment-information>

    <!-- Shipment notify pull back ready -->
    <dialog-notify-pull-back-ready
      v-model="selectedShipment"
      :dialog="dialogNotifyPullBackReady"
      v-on:dialog-close="onDialogClose"
    ></dialog-notify-pull-back-ready>

    <dialog-manage-quotation
      v-if="dialogManageQuotation"
      :dialog="dialogManageQuotation"
      v-model="selectedShipmentQuotation"
      v-on:dialog-close="onDialogManageQuotationClose"
    ></dialog-manage-quotation>

    <!-- Dialog for managing shipment files upload -->
    <dialog-file-cabinet
      v-model="selectedShipmentId"
      :company_id="selectedCompanyId"
      :dialog="dialogFileCabinet"
      :isBooking="false"
      v-on:dialog-close="onDialogClose"
    ></dialog-file-cabinet>

    <!-- Dialog for Comment Message Box -->
    <dialog-message-notifier
      :dialog="dialogMessageNotifierAdminCustomer"
      v-model="message_notifier_comment"
      v-on:dialog-close="onDialogCloseMessageNotifier"
    ></dialog-message-notifier>
    <!-- End of dialogs -->

    <!-- Display shipment tracking information -->
    <v-dialog
      v-model="dialogTrackingInfo"
      max-width="600"
      :retain-focus="false"
    >
      <v-card v-if="shipment != null" color="white" tile flat>
        <v-card-title class="dialog-header-title">
          Shipment {{ shipment.shipment_order_id }} Tracking Detail
        </v-card-title>
        <v-card-text class="px-0 pb-1">
          <v-row no-gutters class="pt-4">
            <v-col>
              <v-row class="pl-3">
                <span class="body-2 font-weight-bold primary--text mr-2"
                  >Tracking ID:</span
                >
                <span class="font-weight-bold">{{ shipment.tracking_id }}</span>
              </v-row>

              <v-row>
                <v-divider></v-divider>
              </v-row>

              <v-row class="pl-3 pt-2">
                <span class="body-2 font-weight-bold primary--text mr-2"
                  >Tracking Link:</span
                >
                <span class="font-weight-bold pr-2">{{ tracking_link }}</span>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      icon
                      color="primary"
                      class="pb-1"
                      @click="toCopyLink()"
                    >
                      <v-icon size="15">mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  Copy to clipboard
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      icon
                      color="primary"
                      class="pb-1"
                      @click="openLink"
                    >
                      <v-icon size="15">mdi-open-in-new</v-icon>
                    </v-btn>
                  </template>
                  Open link in new tab
                </v-tooltip>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-row>
          <v-divider></v-divider>
        </v-row>

        <v-card-actions>
          <v-row justify="center">
            <v-btn
              class="font-weight-bold ml-2"
              color="error"
              small
              tile
              depressed
              @click="dialogTrackingInfo = false"
              >CANCEL</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Update the selected shipment workflow process -->
    <v-dialog v-model="dialogUpdateWorkflowProcess" max-width="680">
      <v-card v-if="selectedProcess.process != null" color="white" tile flat>
        <v-row no-gutters>
          <v-col>
            <v-card color="white" tile flat>
              <v-card-title
                :class="`${
                  setProcessStyle(selectedProcess).color
                } white--text py-1`"
              >
                <v-row no-gutters>
                  <v-col>
                    <v-row>
                      <span class="title"
                        >[{{ shipment.shipment_order_id }}] Workflow
                        Update</span
                      >
                    </v-row>
                    <v-row>
                      <span class="body-1">
                        {{ selectedProcess.alias }} ({{
                          setProcessStyle(selectedProcess).title
                        }})
                      </span>
                    </v-row>
                  </v-col>

                  <v-col cols="1" class="d-flex justify-content-end pt-2">
                    <v-btn
                      x-small
                      icon
                      color="white"
                      @click="dialogUpdateWorkflowProcess = false"
                    >
                      <v-icon size="30">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-title>

              <v-card-text class="pb-1 px-1">
                <template
                  v-if="
                    ['shipment_to_port', 'shipment_delivery'].includes(
                      selectedProcess.process
                    )
                  "
                >
                  <v-row no-gutters class="pt-2 px-3">
                    <v-col>
                      <v-card tile flat color="white">
                        <template
                          v-if="
                            shipment.quotation_type !=
                            CONSTANT.QUOTATION_TYPE_SEA_FCL
                          "
                        >
                          <v-row
                            dense
                            v-if="
                              selectedProcess.process == 'shipment_to_port' &&
                              transport_export_info != null
                            "
                          >
                            <v-col>
                              <v-row no-gutters>
                                <v-col>
                                  <time-window
                                    v-model="
                                      transport_export_info.transport_export
                                        .schedule
                                    "
                                    schedule-description="Pick up schedule"
                                  ></time-window>
                                </v-col>
                              </v-row>

                              <v-row justify="center" class="pt-2">
                                <v-btn
                                  class="mx-2 font-weight-bold"
                                  depressed
                                  tile
                                  small
                                  color="primary"
                                  @click="
                                    updateShipmentInformation(
                                      transport_export_info
                                    )
                                  "
                                  >UPDATE</v-btn
                                >
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row
                            dense
                            v-if="
                              selectedProcess.process == 'shipment_delivery' &&
                              transport_import_info != null
                            "
                          >
                            <v-col>
                              <v-row no-gutters>
                                <v-col>
                                  <time-window
                                    v-model="
                                      transport_import_info.transport_import
                                        .schedule
                                    "
                                    schedule-description="Pick up schedule"
                                  ></time-window>
                                </v-col>
                              </v-row>

                              <v-row justify="center" class="pt-2">
                                <v-btn
                                  class="mx-2 font-weight-bold"
                                  depressed
                                  tile
                                  small
                                  color="primary"
                                  @click="
                                    updateShipmentInformation(
                                      transport_import_info
                                    )
                                  "
                                  >UPDATE</v-btn
                                >
                              </v-row>
                            </v-col>
                          </v-row>
                        </template>

                        <template v-else>
                          <v-row
                            no-gutters
                            v-if="
                              selectedProcess.process == 'shipment_to_port' &&
                              haulage_export_info != null
                            "
                          >
                            <v-col>
                              <v-row dense>
                                <v-col>
                                  <time-window
                                    v-model="
                                      haulage_export_info.haulage_export
                                        .delivery_schedule
                                    "
                                    schedule-description="Deliver container"
                                  ></time-window>
                                </v-col>
                              </v-row>

                              <v-row dense>
                                <v-col>
                                  <time-window
                                    v-model="
                                      haulage_export_info.haulage_export
                                        .pull_back_schedule
                                    "
                                    schedule-description="Pull-back container"
                                  ></time-window>
                                </v-col>
                              </v-row>

                              <v-row justify="center" class="pt-2">
                                <v-btn
                                  class="mx-2 font-weight-bold"
                                  depressed
                                  tile
                                  small
                                  color="primary"
                                  @click="
                                    updateShipmentInformation(
                                      haulage_export_info
                                    )
                                  "
                                  >UPDATE</v-btn
                                >
                              </v-row>
                            </v-col>
                          </v-row>

                          <v-row
                            no-gutters
                            v-if="
                              selectedProcess.process == 'shipment_delivery' &&
                              haulage_import_info != null
                            "
                          >
                            <v-col>
                              <v-row dense>
                                <v-col>
                                  <time-window
                                    v-model="
                                      haulage_import_info.haulage_import
                                        .delivery_schedule
                                    "
                                    schedule-description="Deliver container"
                                  ></time-window>
                                </v-col>
                              </v-row>

                              <v-row dense>
                                <v-col>
                                  <time-window
                                    v-model="
                                      haulage_import_info.haulage_import
                                        .pull_back_schedule
                                    "
                                    schedule-description="Pull-back container"
                                  ></time-window>
                                </v-col>
                              </v-row>

                              <v-row justify="center" class="pt-2">
                                <v-btn
                                  class="mx-2 font-weight-bold"
                                  depressed
                                  tile
                                  small
                                  color="primary"
                                  @click="
                                    updateShipmentInformation(
                                      haulage_import_info
                                    )
                                  "
                                  >UPDATE</v-btn
                                >
                              </v-row>
                            </v-col>
                          </v-row>
                        </template>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-divider class="my-1 py-1"></v-divider>
                  </v-row>
                </template>

                <template
                  v-if="
                    [
                      'vessel_departure',
                      'vessel_in_transit',
                      'vessel_arrival',
                    ].includes(selectedProcess.process)
                  "
                >
                  <v-row>
                    <v-divider class="my-0"></v-divider>
                  </v-row>

                  <v-row no-gutters>
                    <v-col>
                      <v-card v-if="shipment_schedule_info != null" flat tile>
                        <v-card-title class="primary--text title py-1">
                          Update shipment schedule
                        </v-card-title>

                        <!-- <v-divider class="my-0 py-0"></v-divider> -->

                        <v-card-text class="py-0 px-0">
                          <v-row
                            v-if="
                              [
                                'vessel_departure',
                                'vessel_in_transit',
                              ].includes(selectedProcess.process)
                            "
                          >
                            <v-col cols="12" sm="6" md="6">
                              <span>Origin ETA:</span>
                              <flat-pickr
                                v-model="
                                  shipment_schedule_info.shipment_schedule
                                    .origin_eta
                                "
                                class="form-control"
                                :config="config"
                                style="background: white"
                                placeholder="Select date and time"
                                name="date"
                              ></flat-pickr>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                              <span>Origin ETD:</span>
                              <flat-pickr
                                v-model="
                                  shipment_schedule_info.shipment_schedule
                                    .origin_etd
                                "
                                class="form-control"
                                :config="config"
                                style="background: white"
                                placeholder="Select date and time"
                                name="date"
                              ></flat-pickr>
                            </v-col>
                          </v-row>

                          <v-row
                            v-if="
                              ['vessel_in_transit', 'vessel_arrival'].includes(
                                selectedProcess.process
                              )
                            "
                          >
                            <v-col cols="12" sm="6" md="6">
                              <span>Destination ETA:</span>
                              <flat-pickr
                                v-model="
                                  shipment_schedule_info.shipment_schedule
                                    .destination_eta
                                "
                                class="form-control"
                                :config="config"
                                style="background: white"
                                placeholder="Select date and time"
                                name="date"
                              ></flat-pickr>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                              <span>Destination ETD:</span>
                              <flat-pickr
                                v-model="
                                  shipment_schedule_info.shipment_schedule
                                    .destination_etd
                                "
                                class="form-control"
                                :config="config"
                                style="background: white"
                                placeholder="Select date and time"
                                name="date"
                              ></flat-pickr>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <span>Vessel Name:</span>
                              <input
                                v-model="
                                  shipment_schedule_info.shipment_schedule
                                    .vessel_name
                                "
                                class="form-control"
                              />
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                              <span>Vessel Voyage:</span>
                              <input
                                v-model="
                                  shipment_schedule_info.shipment_schedule
                                    .vessel_voyage
                                "
                                class="form-control"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>

                        <!-- <v-divider></v-divider> -->

                        <v-card-actions>
                          <v-row justify="center">
                            <v-btn
                              class="mx-2 font-weight-bold button"
                              depressed
                              tile
                              small
                              color="primary"
                              @click="
                                updateShipmentScheduleOverride(
                                  shipment_schedule_info.shipment_schedule
                                )
                              "
                              >UPDATE</v-btn
                            >
                            <!-- <v-btn
                      class="mx-2 font-weight-bold button"
                      depressed
                      tile
                      small
                      color="error"
                      @click="dialogUpdateWorkflowProcess = false"
                      >CLOSE</v-btn
                    > -->
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-divider class="my-0"></v-divider>
                  </v-row>
                </template>

                <v-row>
                  <v-col cols="5">
                    <span>Start Date:</span>
                    <flat-pickr
                      v-model="selectedProcess.meta_data.start.datetime"
                      class="form-control"
                      style="background: white"
                      placeholder="Select date time"
                      :config="config"
                      name="date"
                    ></flat-pickr>
                  </v-col>

                  <v-spacer></v-spacer>

                  <v-col cols="5">
                    <span>
                      Complete Date:
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            icon
                            x-small
                            @click="
                              selectedProcess.meta_data.end.datetime = null
                            "
                          >
                            <v-icon color="error" size="23">mdi-close</v-icon>
                          </v-btn>
                        </template>
                        Clear the complete datetime
                      </v-tooltip>
                    </span>
                    <flat-pickr
                      v-model="selectedProcess.meta_data.end.datetime"
                      class="form-control"
                      style="background: white"
                      placeholder="Select date time"
                      :config="config"
                      name="date"
                    ></flat-pickr>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-row justify="center" class="py-2 px-9">
                  <!-- Show Start button only if start status is false -->
                  <v-btn
                    v-show="!selectedProcess.meta_data.start.status"
                    small
                    class="font-weight-bold mr-2"
                    color="primary"
                    tile
                    depressed
                    @click="updateWorkflowProcess(true, false, false)"
                    >START</v-btn
                  >

                  <!-- Show Complete button only if end status is false -->
                  <v-btn
                    v-show="!selectedProcess.meta_data.end.status"
                    small
                    class="font-weight-bold mx-2"
                    color="success"
                    tile
                    depressed
                    @click="updateWorkflowProcess(false, true, false)"
                    >COMPLETE</v-btn
                  >

                  <!-- Show Undo button only if the start status is true -->
                  <v-btn
                    v-show="selectedProcess.meta_data.start.status"
                    small
                    class="font-weight-bold ml-2"
                    color="error"
                    tile
                    depressed
                    @click="updateWorkflowProcess(false, false, true)"
                    >UNDO</v-btn
                  >
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- cancel shipment dialog -->
    <v-dialog v-model="dialogCancelShipment" max-width="350">
      <v-card flat tile color="white">
        <v-card-text class="px-0 py-0">
          <v-alert type="info" text dense>
            Are you sure you want to cancel shipment
            <strong>{{ shipment.shipment_order_id }}</strong
            >?
          </v-alert>
        </v-card-text>

        <v-divider class="mt-0"></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              small
              tile
              depressed
              color="primary"
              class="font-weight-bold text-button mx-3"
              @click="cancelShipment"
              >YES</v-btn
            >
            <v-btn
              small
              tile
              depressed
              color="error"
              class="font-weight-bold text-button"
              @click="dialogCancelShipment = false"
              >NO</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="snackbarTop"
      :right="snackbarRight"
      :bottom="snackbarBottom"
      tile
    >
      {{ snackbarMsg }}
      <v-btn v-show="showSnackbarBtn" dark text @click="showSnackbar = false"
        >CLOSE</v-btn
      >
    </v-snackbar>

    <v-row no-gutters>
      <v-col>
        <v-card tile flat>
          <v-row no-gutters style="background-color: white" class="pt-2">
            <v-col>
              <v-row justify="start" class="pb-3">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      icon
                      color="primary"
                      class="mx-2"
                      @click="onShipmentInfoDialog"
                    >
                      <v-icon size="25">mdi-tune</v-icon>
                    </v-btn>
                  </template>
                  <span>Manage shipment Information</span>
                </v-tooltip>

                <template v-if="$root.is_admin">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-badge
                        class="font-weight-bold"
                        :content="file_count"
                        :value="file_count"
                        color="amber darken-4"
                        overlap
                        bordered
                        left
                        offset-x="17"
                        offset-y="11"
                      >
                        <v-btn
                          v-on="on"
                          x-small
                          icon
                          color="primary"
                          class="mx-2"
                          @click="onOpenShipmentFileCabinet"
                        >
                          <v-icon size="23">mdi-file-multiple</v-icon>
                        </v-btn>
                      </v-badge>
                    </template>
                    Shipment files
                  </v-tooltip>
                </template>

                <template v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        x-small
                        icon
                        color="primary"
                        class="mx-2"
                        @click="onOpenShipmentFileCabinet"
                      >
                        <v-icon size="23">mdi-file-multiple</v-icon>
                      </v-btn>
                    </template>
                    <span>Shipment files</span>
                  </v-tooltip>
                </template>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-show="
                        shipment.quotation_type ==
                        CONSTANT.QUOTATION_TYPE_SEA_FCL
                      "
                      v-on="on"
                      x-small
                      icon
                      color="primary"
                      class="mx-2"
                      @click="
                        onShipmentDialog(CONSTANT.DIALOG_NOTIFY_PULL_BACK_READY)
                      "
                    >
                      <v-icon size="25">mdi-bell-alert</v-icon>
                    </v-btn>
                  </template>
                  <span>Notify for pull back</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      icon
                      color="primary"
                      class="mx-2"
                      @click="onDisplayTrackingInfo()"
                    >
                      <v-icon size="25">mdi-link-box-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>Shipment tracking link</span>
                </v-tooltip>

                <!-- <v-spacer></v-spacer> -->

                <template v-if="$root.is_admin">
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        x-small
                        icon
                        color="secondary"
                        class="ml-4 mr-2"
                        @click="onIssueQuotationInvoice()"
                      >
                        <v-icon size="23">mdi-receipt</v-icon>
                      </v-btn>
                    </template>
                    Issue a new invoice
                  </v-tooltip> -->

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        x-small
                        icon
                        color="secondary"
                        class="mx-2"
                        @click="onManageQuotation"
                      >
                        <v-icon size="25">mdi-square-edit-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit shipment parameters under quotation</span>
                  </v-tooltip>

                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        x-small
                        icon
                        color="error"
                        class="mx-2"
                        @click="onCancelShipment"
                      >
                        <v-icon size="25">mdi-cancel</v-icon>
                      </v-btn>
                    </template>
                    <span>Cancel shipment</span>
                  </v-tooltip>
                </template>
              </v-row>
            </v-col>

            <v-col
              cols="2"
              class="d-flex justify-end pr-4"
              v-if="
                $root.is_admin && shipment.completed && !shipment.issued_invoice
              "
            >
              <template>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      dark
                      outlined
                      tile
                      color="amber darken-4"
                      class="font-weight-bold text-md-caption px-1"
                      @click="markAsIssuedInvoice()"
                      ><v-icon size="15" class="mr-1">mdi-receipt</v-icon
                      >Invoice issued</v-btn
                    >
                  </template>
                  Mark as issued invoice
                </v-tooltip>
              </template>
            </v-col>
          </v-row>

          <v-row>
            <v-divider class="mt-0"></v-divider>
          </v-row>

          <v-row no-gutters justify="center" class="py-2 px-6">
            <template v-for="(wf_item, ind) in workflowProcesses">
              <v-col
                style="max-width: 12%"
                :key="`hr${ind}`"
                v-if="ind !== 0"
                class="mr-n13"
              >
                <hr
                  :class="`hr-line mt-3 ml-n13 ${
                    setProcessStyle(wf_item).color
                  }`"
                />
              </v-col>

              <v-col style="max-width: 80px">
                <v-row>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-responsive
                        :key="ind"
                        v-on="on"
                        :class="`rounded-circle text-center align-center justify-center ${
                          setProcessStyle(wf_item).color
                        }`"
                        style="cursor: pointer"
                        height="28"
                        max-width="28"
                        @click="onUpdateWorkflowProcess(wf_item)"
                      >
                        <v-icon size="18" color="white">
                          {{ setWorkflowIcon(wf_item) }}
                        </v-icon>
                      </v-responsive>
                    </template>
                    {{ wf_item.alias }}
                  </v-tooltip>
                </v-row>

                <v-row class="py-1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-row v-on="on" no-gutters class="caption">
                        <span>{{ setWFProcessLabel(wf_item).line_1 }}</span>
                      </v-row>
                    </template>
                    <span>{{ setWFProcessLabel(wf_item).line_1_tooltip }}</span>
                  </v-tooltip>
                </v-row>

                <v-row>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-row no-gutters v-on="on" class="caption-line-2">
                        {{ setWFProcessLabel(wf_item).line_2 }}
                      </v-row>
                    </template>
                    <span>{{ setWFProcessLabel(wf_item).line_2_tooltip }}</span>
                  </v-tooltip>
                </v-row>
              </v-col>
            </template>
          </v-row>

          <v-row>
            <v-divider class="mb-0"></v-divider>
          </v-row>

          <v-row>
            <v-card flat width="100%" color="white" class="pb-2">
              <v-row no-gutters class="pr-4">
                <v-col>
                  <v-tabs left v-model="messageCenterTab">
                    <v-tab :key="1">Message Center</v-tab>
                  </v-tabs>
                </v-col>

                <v-col class="d-flex justify-content-end align-center">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon @click="fetchMessages()">
                        <v-icon size="30" color="primary">mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    Reload message center
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col>
                  <v-tabs-items v-model="messageCenterTab">
                    <v-tab-item :key="1">
                      <v-row no-gutters>
                        <v-col>
                          <v-row v-if="sortedMessageList.length > 0" no-gutters>
                            <v-col class="px-1 pt-1">
                              <v-card
                                tile
                                flat
                                color="white"
                                class="pa-2"
                                min-height="100"
                              >
                                <template
                                  v-for="(comment, i) in sortedMessageList"
                                >
                                  <v-row :key="i">
                                    <v-alert
                                      color="primary"
                                      border="left"
                                      elevation="0"
                                      colored-border
                                      tile
                                      min-width="100%"
                                      icon="mdi-message"
                                      class="pb-0 pt-1 pr-1"
                                      clearable
                                    >
                                      <v-row class="pb-1" no-gutters>
                                        <v-col>
                                          <span
                                            class="caption font-weight-bold"
                                            >{{ comment.message }}</span
                                          >
                                        </v-col>

                                        <v-col
                                          v-if="$root.is_admin"
                                          cols="1"
                                          class="d-flex justify-content-end"
                                        >
                                          <v-icon
                                            :color="
                                              comment.category == 'quotation'
                                                ? 'teal'
                                                : 'primary'
                                            "
                                            size="20"
                                            class="px-0"
                                            @click="deleteMessage(comment)"
                                            >mdi-close-circle-outline</v-icon
                                          >
                                        </v-col>
                                      </v-row>

                                      <v-row justify="space-between">
                                        <span class="sub-comment-text">{{
                                          comment.createdStr
                                        }}</span>

                                        <v-chip
                                          x-small
                                          label
                                          text-color="white"
                                          :color="
                                            comment.category == 'quotation'
                                              ? 'teal'
                                              : 'primary'
                                          "
                                          class="px-1 font-weight-bold"
                                          >{{ comment.category }}</v-chip
                                        >

                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on }">
                                            <v-btn
                                              x-small
                                              icon
                                              dark
                                              v-on="on"
                                              v-if="$root.is_admin"
                                              @click="
                                                onMessageNotifierAdminCustomer(
                                                  comment
                                                )
                                              "
                                              :color="
                                                comment.admin_notified ||
                                                comment.customer_notified
                                                  ? 'success'
                                                  : 'primary'
                                              "
                                              ><v-icon
                                                >mdi-bell-ring</v-icon
                                              ></v-btn
                                            >
                                          </template>
                                          {{
                                            comment.admin_notified ||
                                            comment.customer_notified
                                              ? "Notify admin or customer"
                                              : "Notification sent"
                                          }}
                                        </v-tooltip>

                                        <span class="sub-comment-text">{{
                                          comment.first_name
                                        }}</span>
                                      </v-row>
                                    </v-alert>
                                  </v-row>
                                  <v-divider
                                    :key="`${i}divider`"
                                    class="my-2"
                                  ></v-divider>
                                </template>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row v-else justify="center" class="mt-4">
                            <v-alert
                              icon="mdi-information"
                              dense
                              text
                              type="error"
                              >No comment available yet</v-alert
                            >
                          </v-row>
                        </v-col>

                        <template v-if="$root.is_admin">
                          <v-divider vertical></v-divider>

                          <v-col cols="12" md="3">
                            <v-row>
                              <v-col>
                                <v-row>
                                  <v-textarea
                                    class="modified-text-field caption mb-3"
                                    label="Post message"
                                    dense
                                    outlined
                                    auto-grow
                                    hide-details
                                    rows="3"
                                    row-height="25"
                                    clearable
                                    v-model="message"
                                  ></v-textarea>
                                </v-row>
                                <v-row justify="end">
                                  <v-btn
                                    :disabled="
                                      message == null || message.length < 1
                                    "
                                    tile
                                    class="font-weight-bold body-2"
                                    color="primary"
                                    @click="postMessage"
                                    >POST</v-btn
                                  >
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                        </template>
                      </v-row>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-card>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "../../const"
import moment from "moment"
import TimeWindow from "@/components/shared/TimeWindow.vue"
import flatPickr from "vue-flatpickr-component"
import firebase from "firebase/app"
import "firebase/firestore"
import "flatpickr/dist/flatpickr.css"
import "flatpickr/dist/themes/airbnb.css"
import DialogShipmentInformation from "@/components/user/DialogShipmentInformation"
import DialogManageQuotation from "@/components/admin/dialogs/DialogManageQuotation"
import DialogMessageNotifier from "@/components/user/DialogMessageNotifier.vue"

export default {
  props: ["shipment", "color"],
  components: {
    TimeWindow,
    flatPickr,
    DialogShipmentInformation,
    DialogManageQuotation,
    DialogMessageNotifier,
  },
  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      snackbarTop: true,
      snackbarRight: false,
      snackbarBottom: false,
      showSnackbarBtn: true,

      config: {
        altInput: true,
        altFormat: "M j, Y h:i K",
        altInputClass: "flatpickr-alt-input",
        enableTime: true,
        dateFormat: "Y-m-d H:i:S",
        time_24hr: true,
        position: "auto",
      },

      selectedTab: 0,

      dialogUpdateWorkflowProcess: false,
      dialogShipmentInformation: false,
      dialogNotifyPullBackReady: false,
      dialogManageQuotation: false,
      dialogOnNewShipmentTask: false,
      dialogTrackingInfo: false,
      dialogFileCabinet: false,
      dialogMessageNotifierAdminCustomer: false,
      dialogCancelShipment: false,

      message_notifier_comment: null,

      tracking_link: null,

      selectedShipment: null,
      selectedShipmentId: null,
      selectedCompanyId: null,
      selectedShipmentQuotation: null,

      selectedProcess: {},
      new_task: null,

      message: null,
      messageList: [],
      messageCenterTab: 1,
      collectionComments: "comments",
      collectionMessages: "messages",

      file_count: 0,
    }
  },
  // created() {
  //   // get the file count real time number
  //   this.getFileCount();
  // },
  mounted() {
    // fetch comment for the message center
    this.fetchMessages()

    // get the file count real time number
    this.getFileCount()
  },
  watch: {},

  methods: {
    /**
     * set the process style
     * @param {object} wf_item
     */
    setProcessStyle(wf_item) {
      var color = ""
      var title = ""

      // If in Progress
      if (wf_item.meta_data.start.status && !wf_item.meta_data.end.status) {
        color = "amber darken-4"
        title = "In Progress"
      }
      // If Completed
      else if (wf_item.meta_data.start.status && wf_item.meta_data.end.status) {
        color = "green darken-3"
        title = "Completed"
      }
      // not started
      else {
        color = "grey"
        title = "Not Started"
      }
      return { color: color, title: title }
    },

    /**
     * Set the workflow icon
     */
    setWorkflowIcon(wf_item) {
      let icon = constant.WORKFLOW_FORMAT[wf_item.process].icon
      if (this.shipment.quotation_type == constant.QUOTATION_TYPE_AIR) {
        if (wf_item.process == "vessel_departure") {
          icon = "mdi-airplane-takeoff"
        } else if (wf_item.process == "vessel_in_transit") {
          icon = "mdi-airplane mdi-rotate-90"
        } else if (wf_item.process == "vessel_arrival") {
          icon = "mdi-airplane-landing"
        }
      }
      return icon
    },

    /**
     * Set the Label messgae for the stepper workflow
     * @param {object} wf_item
     */
    setWFProcessLabel(wf_item) {
      var line_1 = ""
      var line_2 = ""
      var line_1_tooltip = null
      var line_2_tooltip = null

      // If Shipment to port (Export)
      if (wf_item.process == "shipment_to_port") {
        // if FCL (Haulage)
        if (this.shipment.quotation_type == constant.QUOTATION_TYPE_SEA_FCL) {
          // if the milestone is completed, then use milestone datetime as actual
          //* line 1 (delivery Schedule)
          if (wf_item.meta_data.start.status) {
            line_1 = `D: ${moment(wf_item.meta_data.start.datetime).format(
              "MMM DD"
            )}`

            line_1_tooltip = "Container delivery"
          }
          // else use the planned haulage schedule
          else {
            line_1 = `D: ${
              this.shipment.haulage_export.delivery_schedule
                .start_datetime_str || "N/A"
            }`

            line_1_tooltip = "Container delivery"
          }

          //* line 2 (Pull Back Schedule)
          if (wf_item.meta_data.end.status) {
            line_2 = `C: ${moment(wf_item.meta_data.end.datetime).format(
              "MMM DD"
            )}`

            line_2_tooltip = "Containter collection"
          }
          // else use the planned haulage schedule
          else {
            line_2 = `C: ${
              this.shipment.haulage_export.pull_back_schedule
                .start_datetime_str || "N/A"
            }`

            line_2_tooltip = "Containter collection"
          }
        }
        // if LCL or AIR (Transport)
        else {
          // if the milestone is completed, then use milestone datetime as actual
          //* (Transport Export Schedule)
          if (wf_item.meta_data.end.status) {
            line_1 = `P: ${moment(wf_item.meta_data.end.datetime).format(
              "MMM DD"
            )}`

            line_1_tooltip = "Cargo pickup"
          }
          // else use the planned haulage schedule
          else {
            line_1 = `P: ${
              this.shipment.transport_export.schedule.start_datetime_str ||
              "N/A"
            }`
            line_1_tooltip = "Cargo pickup"
          }
        }
      }
      // If Shipment Delivery (Import)
      else if (wf_item.process == "shipment_delivery") {
        // If FCL (Haulage)
        if (this.shipment.quotation_type == constant.QUOTATION_TYPE_SEA_FCL) {
          // if the milestone is completed, then use milestone datetime as actual
          //* line 1 (delivery Schedule)
          if (wf_item.meta_data.start.status) {
            line_1 = `D: ${moment(wf_item.meta_data.start.datetime).format(
              "MMM DD"
            )}`

            line_1_tooltip = "Container delivery"
          }
          // else use the planned haulage schedule
          else {
            line_1 = `D: ${
              this.shipment.haulage_import.delivery_schedule
                .start_datetime_str || "N/A"
            }`

            line_1_tooltip = "Container delivery"
          }

          //* line 2 (Pull Back Schedule)
          if (wf_item.meta_data.end.status) {
            line_2 = `C: ${moment(wf_item.meta_data.end.datetime).format(
              "MMM DD"
            )}`

            line_2_tooltip = "Containter collection"
          }
          // else use the planned haulage schedule
          else {
            line_2 = `C: ${
              this.shipment.haulage_import.pull_back_schedule
                .start_datetime_str || "N/A"
            }`

            line_2_tooltip = "Containter collection"
          }
        }
        // if LCL or AIR (Transport)
        else {
          // if the milestone is completed, then use milestone datetime as actual
          //* (Transport Import Schedule)
          if (wf_item.meta_data.end.status) {
            line_1 = `D: ${moment(wf_item.meta_data.end.datetime).format(
              "MMM DD"
            )}`

            line_1_tooltip = "Cargo delivery"
          }
          // else use the planned haulage schedule
          else {
            line_1 = `D: ${
              this.shipment.transport_import.schedule.start_datetime_str ||
              "N/A"
            }`
            line_1_tooltip = "Cargo delivery"
          }
        }
      }

      //* Shipment Schedule
      // Vessel Departure
      else if (wf_item.process == "vessel_departure") {
        line_1 = this.shipment.quotation.origin_port.un_code
        line_1_tooltip = this.shipment.quotation.origin_port.label

        // use ETD for Air
        if (this.shipment.quotation_type == constant.QUOTATION_TYPE_AIR) {
          line_2 = "ETD: N/A"
          line_2_tooltip = "Estimated time of departure"

          // if atd, use the milestone time
          if (wf_item.meta_data.end.status) {
            line_2 = `ATD: ${moment(wf_item.meta_data.end.datetime).format(
              "MMM DD"
            )}`
            line_2_tooltip = "Actual time of departure"
          }
          // else use the origin eta
          else if (
            this.shipment.quotation.shipment_schedule.origin_etd != null
          ) {
            // if etd
            line_2 = `ETD: ${this.shipment.quotation.shipment_schedule.origin_etd_string}`
            line_2_tooltip = "Estimated time of departure"
          }
        }
        // if FCL or LCL
        else {
          line_2 = "ETA: N/A"
          line_2_tooltip = "Estimated time of arrival"
          // if atd, use the milestone time
          if (wf_item.meta_data.end.status) {
            line_2 = `ATD: ${moment(wf_item.meta_data.end.datetime).format(
              "MMM DD"
            )}`
            line_2_tooltip = "Actual time of departure"
          }
          // else use origin eta
          else if (
            this.shipment.quotation.shipment_schedule.origin_eta != null
          ) {
            line_2 = `ETA: ${this.shipment.quotation.shipment_schedule.origin_eta_string}`
            line_2_tooltip = "Estimated time of arrival"
          }
        }
      }
      // Vessel Arrival
      else if (wf_item.process == "vessel_arrival") {
        line_1 = this.shipment.quotation.destination_port.un_code
        line_1_tooltip = this.shipment.quotation.destination_port.label
        line_2 = "ETA: N/A"
        line_2_tooltip = "Estimated time of arrival"

        // if ata is not null, then use the Actual Time of arrival
        // if atd, use the milestone time
        if (wf_item.meta_data.start.status) {
          line_2 = `ATA: ${moment(wf_item.meta_data.start.datetime).format(
            "MMM DD"
          )}`
          line_2_tooltip = "Actual time of arrival"
        }
        // else use the destination eta
        else if (
          this.shipment.quotation.shipment_schedule.destination_eta != null
        ) {
          line_2 = `ETA: ${this.shipment.quotation.shipment_schedule.destination_eta_string}`
          line_2_tooltip = "Estimated time of arrival"
        }
      }

      // Vessel in transit
      else if (wf_item.process == "vessel_in_transit") {
        line_1 = "Transit"
        line_1_tooltip = wf_item.alias
      }

      // Export clearance
      else if (wf_item.process == "export_clearance") {
        line_1 = "Customs"
        line_1_tooltip = wf_item.alias
      }

      // Import clearance
      else if (wf_item.process == "import_clearance") {
        line_1 = "Customs"
        line_1_tooltip = wf_item.alias
      }

      // shipment closed
      else if (wf_item.process == "shipment_closed") {
        line_1 = "Completed"
        line_1_tooltip = wf_item.alias
      }

      return {
        line_1: line_1,
        line_2: line_2,
        line_1_tooltip: line_1_tooltip,
        line_2_tooltip: line_2_tooltip,
      }
    },

    /** On update the shipment workflow */
    onUpdateWorkflowProcess(process) {
      if (this.$root.is_admin && process.included) {
        this.selectedProcess = process

        // pre-set the start datetime
        if (
          this.selectedProcess.meta_data.start.datetime == null ||
          this.selectedProcess.meta_data.start.datetime == ""
        ) {
          this.selectedProcess.meta_data.start.datetime = moment().format(
            "YYYY-MM-DD HH:mm:ss"
          )
        }

        // pre-set the end datetime
        if (
          this.selectedProcess.meta_data.end.datetime == null ||
          this.selectedProcess.meta_data.end.datetime == ""
        ) {
          this.selectedProcess.meta_data.end.datetime = moment().format(
            "YYYY-MM-DD HH:mm:ss"
          )
        }

        // open dialog
        this.dialogUpdateWorkflowProcess = true
      }
    },

    /**
     * Update workflow process
     */
    async updateWorkflowProcess(start = false, complete = false, undo = false) {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Updating workflow process..."
      // postform to update
      var postform = {
        process: this.selectedProcess.process,
        start: start,
        complete: complete,
        undo_process: undo,
        start_dt: null,
        end_dt: null,
      }

      // if started
      if (start) {
        // set the date time
        postform.start_dt = this.selectedProcess.meta_data.start.datetime

        // set the status
        this.selectedProcess.meta_data.start.status = true

        // reset the end datetime
        this.selectedProcess.meta_data.end.datetime = null
      }
      // if completed
      else if (complete) {
        if (
          this.selectedProcess.meta_data.end.datetime == null ||
          this.selectedProcess.meta_data.end.datetime == ""
        ) {
          this.selectedProcess.meta_data.end.datetime = moment().format(
            "YYYY-MM-DD HH:mm:ss"
          )
        }

        // validate that end datetime >= start datetime
        if (
          this.selectedProcess.meta_data.start.datetime >
          this.selectedProcess.meta_data.end.datetime
        ) {
          this.showSnackbar = true
          this.snackbarColor = "orange darken-2"
          this.snackbarMsg =
            "[Invalid datetime]: Start datetime cannot be after the complete datetime"

          this.$root.blockUIshow = false
          return
        }

        // set the end date time
        postform.end_dt = this.selectedProcess.meta_data.end.datetime

        // set the start date time if start status is false
        if (!this.selectedProcess.meta_data.start.status) {
          this.selectedProcess.meta_data.start.datetime = postform.start_dt =
            postform.end_dt
        }

        // set the status
        this.selectedProcess.meta_data.start.status = true
        this.selectedProcess.meta_data.end.status = true

        // if process is vessel departure, then start vessel transit
        if (this.selectedProcess.process == "vessel_departure") {
          for (
            let i = 0;
            i < this.shipment.shipment_workflow.workflow.length;
            i++
          ) {
            const element = this.shipment.shipment_workflow.workflow[i]
            if (element.process == "vessel_in_transit") {
              element.meta_data.start.status = true
              element.meta_data.start.datetime =
                this.selectedProcess.meta_data.end.datetime
              break
            }
          }
        }
      }
      // if undo
      else if (undo) {
        // reset the date time
        this.selectedProcess.meta_data.start.datetime = moment().format(
          "YYYY-MM-DD HH:mm:ss"
        )

        this.selectedProcess.meta_data.end.datetime = null

        // reset the status
        this.selectedProcess.meta_data.start.status = false
        this.selectedProcess.meta_data.end.status = false
      }

      //* Update the shipment schedule for vessel departure
      if (this.selectedProcess.process == "vessel_departure") {
        // if start or complete
        if (start || complete) {
          // vessel departure
          let sd = this.selectedProcess.meta_data.end.datetime || "N/A"

          // update the start date time str
          if (sd != "N/A" && sd != null) {
            // update the ATD
            this.shipment.quotation.shipment_schedule.origin_atd_string =
              moment(sd).format("MMM DD")
          }
        }
      }

      //* Update the shipment schedule for vessel arrival
      else if (this.selectedProcess.process == "vessel_arrival") {
        // if start or complete
        if (start || complete) {
          // vessel departure
          let sd = this.selectedProcess.meta_data.start.datetime || "N/A"

          // update the start date time str
          if (sd != "N/A" && sd != null) {
            // update the ATA
            this.shipment.quotation.shipment_schedule.destination_ata_string =
              moment(sd).format("MMM DD")
          }
        }
      }

      let resp = await this.$https.put(
        `/api/workflow/${this.shipment.shipment_order_id}`,
        postform
      )

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.dialogUpdateWorkflowProcess = false
        this.selectedProcess = {}

        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = resp.data.msg
      } else {
        // this.$root.blockUIshow = false;
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }

      this.$root.blockUIshow = false
    },

    /**
     * Update shipment information
     */
    async updateShipmentInformation(postform) {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Updating shipment information..."

      let resp = await this.$https.put(
        `/api/shipment_orders/${this.shipment.shipment_order_id}`,
        postform
      )
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // update the shipment information
        for (const key in postform) {
          if (postform.hasOwnProperty.call(postform, key)) {
            const element = postform[key]
            this.shipment[key] = element
          }
        }

        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = resp.data.msg
      } else {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }

      this.$root.blockUIshow = false
    },

    /**
     * Update shipment Schedule override information
     */
    async updateShipmentScheduleOverride(postform) {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Updating shipment schedule information..."

      let resp = await this.$https.put(
        `/api/shipment_orders/shipment_schedules/${this.shipment.shipment_order_id}`,
        postform
      )
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // update shipment schedule information
        this.shipment.quotation.shipment_schedule = postform

        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = resp.data.msg
      } else {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }

      this.$root.blockUIshow = false
    },

    /** Mark shipment as issued invoice */
    async markAsIssuedInvoice() {
      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Updating..."

      let postform = {
        status: true,
      }

      let resp = await this.$https.put(
        `/api/shipment_orders/${this.shipment.shipment_order_id}/issued_invoice`,
        postform
      )

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.shipment.issued_invoice = true
        this.onShipmentDeleted()

        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = resp.data.msg
      } else {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }
      this.$root.blockUIshow = false
    },

    /**
     * On display tracking information
     */
    onDisplayTrackingInfo() {
      this.tracking_link = `${constant.HOSTNAME}/tracking?id=${this.shipment.tracking_id}`
      this.dialogTrackingInfo = true
    },

    /**
     * Open link in new tab
     */
    openLink() {
      window.open(this.tracking_link, "_blank")
    },

    /**
     * Copy the link to clipboard
     */
    async toCopyLink() {
      try {
        await this.$copyText(this.tracking_link)
        this.showSnackbar = true
        this.snackbarColor = "secondary"
        this.snackbarMsg = "copied"
        this.snackbarTop = false
        this.snackbarBottom = true
        this.snackbarRight = true
        this.showSnackbarBtn = false
        this.snackbarTimeout = 2000

        // reset snackbar after 3000
        setTimeout(() => {
          this.snackbarTop = true
          this.snackbarBottom = false
          this.snackbarRight = false
          this.showSnackbarBtn = true
        }, 3000)
      } catch (error) {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = error
      }
    },

    /**
     * Fetch messages for this reference
     */
    fetchMessages() {
      this.messageList = []
      this.$root.blockUImsg = "Loading messages..."
      this.$root.blockUIshow = true
      var db = this.$root.messageCenterApp.firestore()
      db.collection(this.collectionComments)
        .doc(this.shipment.shipment_order_id)
        .collection(this.collectionMessages)
        .orderBy("created", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            this.messageList.push(doc.data())
          })
          this.$root.blockUIshow = false
        })
        .catch(function (error) {
          console.log("Error getting document:", error)
          this.$root.blockUIshow = false
        })
    },

    /**
     * Post message to firestore
     */
    postMessage() {
      this.$root.blockUImsg = "Posting message..."
      this.$root.blockUIshow = true
      var db = this.$root.messageCenterApp.firestore()
      // compose the comment object
      let comment = {
        comment_id: null,
        quotation_id: this.shipment.shipment_order_id,
        invoice_id: null,
        category: "shipment", // shipment | quotation | invoice
        company_id: this.shipment.company.company_id,
        company_name: this.shipment.company.name,
        tags: [
          `${this.shipment.quotation_type.toLowerCase()}`,
          `${this.shipment.quotation.transaction_type.toLowerCase()}`,
          `${this.shipment.quotation.incoterm.toLowerCase()}`,
          `${this.shipment.quotation.cargo_type_code.toLowerCase()}`,
        ],
        message: this.message,
        first_name: this.$root.useraccount.first_name,
        last_name: this.$root.useraccount.last_name,
        email: this.$root.useraccount.email,
        uid: this.$root.useraccount.uid,
        account_type: this.$root.useraccount.account_type,
        restricted: false,
        admin_notified: false,
        customer_notified: false,
        createdStr: moment().format("YYYY-MM-DD HH:mm:ss"),
        created: firebase.firestore.FieldValue.serverTimestamp(),
      }
      // write a new comment message
      db.collection(this.collectionComments)
        .doc(this.shipment.shipment_order_id)
        .collection(this.collectionMessages)
        .add(comment)
        .then((docRef) => {
          // update the comment to add the document id as the comment id
          comment.comment_id = docRef.id
          // append comment to messageList
          this.messageList.push(comment)
          this.message = null
          this.$root.blockUIshow = false
          // update the comment id
          db.collection(this.collectionComments)
            .doc(this.shipment.shipment_order_id)
            .collection(this.collectionMessages)
            .doc(docRef.id)
            .update({
              comment_id: docRef.id,
            })
          // Get the doc for this quotation
          // TO check if this is the first comment message
          db.collection(this.collectionComments)
            .doc(this.shipment.shipment_order_id)
            .get()
            .then((doc) => {
              // if doc is empty
              if (!doc.exists) {
                // set the message count
                db.collection(this.collectionComments)
                  .doc(this.shipment.shipment_order_id)
                  .set({
                    count: 1,
                  })
              } else {
                // update the message count
                db.collection(this.collectionComments)
                  .doc(this.shipment.shipment_order_id)
                  .update({
                    count: firebase.firestore.FieldValue.increment(1),
                  })
              }
            })
        })
        .catch((error) => {
          console.error("Error adding document: ", error)
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = error
          this.$root.blockUIshow = false
        })
    },

    /**
     * Delete comment
     */
    deleteMessage(comment) {
      let confirmation = confirm(
        "Are you sure you want to delete this message?"
      )
      if (confirmation) {
        this.$root.blockUImsg = "Deleting message..."
        this.$root.blockUIshow = true
        var db = this.$root.messageCenterApp.firestore()
        db.collection(this.collectionComments)
          .doc(comment.quotation_id)
          .collection(this.collectionMessages)
          .doc(comment.comment_id)
          .delete()
          .then(() => {
            // remove the comment message from the list
            this.messageList = this.messageList.filter((item) => {
              return item != comment
            })
            this.$root.blockUIshow = false

            // update the message count
            db.collection(this.collectionComments)
              .doc(comment.quotation_id)
              .update({
                count: firebase.firestore.FieldValue.increment(-1),
              })
          })
          .catch(function (error) {
            console.error("Error removing document: ", error)
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = error
            this.$root.blockUIshow = false
          })
      }
    },

    /** on Notify admin or customer of message */
    onMessageNotifierAdminCustomer(comment) {
      this.dialogMessageNotifierAdminCustomer = true
      this.message_notifier_comment = comment

      // if admin or customer notify is null
      this.message_notifier_comment.admin_notified =
        comment.admin_notified || false
      this.message_notifier_comment.customer_notified =
        comment.customer_notified || false
    },

    /**
     * on close the message box notifier
     */
    onDialogCloseMessageNotifier() {
      this.dialogMessageNotifierAdminCustomer = false
      this.message_notifier_comment = null
    },

    /**
     * Get the Real Time file count
     */
    getFileCount() {
      // set the comment messages for each quotation
      const firestore_db = this.$root.messageCenterApp.firestore()
      // Get the message count and listen to the document
      firestore_db
        .collection("af-files")
        .doc(this.shipment.company.company_id)
        .collection("shipments")
        .doc(this.shipment.shipment_order_id)
        .onSnapshot((doc) => {
          if (!doc.exists) {
            this.file_count = 0
          } else {
            // get the file count number
            this.file_count = doc.data().file_count
          }
        })
    },

    /**
     * On open shipment information dialog
     */
    onShipmentInfoDialog() {
      this.selectedShipmentId = this.shipment.shipment_order_id
      this.dialogShipmentInformation = true
    },

    /**
     * on open shipment file cabinet
     */
    onOpenShipmentFileCabinet() {
      this.selectedShipmentId = this.shipment.shipment_order_id
      this.selectedCompanyId = this.shipment.company_id
      this.dialogFileCabinet = true
    },

    /**
     * On open shipment dialog
     */
    onShipmentDialog(dialog) {
      this.$root.blockUImsg = "Loading shipment information"
      this.$root.blockUIshow = true
      var response = null

      this.$https
        .get(`/api/shipment_orders/${this.shipment.shipment_order_id}`)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.selectedShipment = response.data

            switch (dialog) {
              case constant.DIALOG_NOTIFY_PULL_BACK_READY:
                this.dialogNotifyPullBackReady = true
                break

              default:
                break
            }
          }

          this.$root.blockUIshow = false
        })
    },

    /**
     * On Create invoice
     */
    onIssueQuotationInvoice() {
      let routeData = this.$router.resolve({
        name: "newinvoice",
        params: { id: this.shipment.shipment_order_id },
      })
      window.open(
        routeData.href + "?id=" + this.shipment.shipment_order_id,
        "_blank"
      )
    },

    /**
     * on manage quotation
     */
    onManageQuotation() {
      this.$root.blockUImsg = "Loading quotation information"
      this.$root.blockUIshow = true
      var response = null

      this.$https
        .get(`/api/quotations/${this.shipment.shipment_order_id}`)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.selectedShipmentQuotation = response.data
            this.dialogManageQuotation = true
          } else {
            console.log("OnManageQuotation Error: ", response)
          }

          this.$root.blockUIshow = false
        })
    },

    /**
     * On Cancel shipment
     */
    onCancelShipment() {
      this.dialogCancelShipment = true
    },

    /**
     * Cancel shipment
     */
    async cancelShipment() {
      this.$root.blockUImsg = "Cancelling shipment"
      this.$root.blockUIshow = true
      try {
        let resp = await this.$https.delete(
          `/api/shipment_orders/${this.shipment.shipment_order_id}/shipment_cancelled`
        )
        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          this.dialogCancelShipment = false
          this.showSnackbar = true
          this.snackbarColor = "success"
          this.snackbarMsg = resp.data.msg

          this.shipment.booking_confirmed = false
        } else {
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = resp.data.msg
        }
      } catch (error) {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = error
      }

      this.$root.blockUIshow = false
    },

    /**
     * On close Dialog Manage Quotation
     */
    onDialogManageQuotationClose(
      quotation,
      hasChange,
      isReAssigned = false,
      newCompany = null
    ) {
      this.dialogManageQuotation = false
      this.selectedShipmentQuotation = null
    },

    /**
     * on clode dialog
     */
    onDialogClose(dialog, object, hasChange) {
      switch (dialog) {
        case constant.DIALOG_SHIPMENT_INFORMARTION:
          this.dialogShipmentInformation = false

          // sync only if hasChange is true
          if (hasChange) {
            // sync the updated shipment
            this.shipment = Object.assign(this.shipment, object)
          }
          break

        case constant.DIALOG_NOTIFY_PULL_BACK_READY:
          this.dialogNotifyPullBackReady = false
          break

        case constant.DIALOG_FILE_CABINET:
          this.dialogFileCabinet = false
          break

        default:
          break
      }

      this.selectedShipment = null
      this.selectedShipmentQuotation = null
      this.selectedShipmentId = null
      this.selectedCompanyId = null
    },

    /**
     * on shipment deleted
     */
    onShipmentDeleted() {
      this.$emit("remove-shipment")
    },
  },

  computed: {
    workflowProcesses() {
      let ret = []

      this.shipment.shipment_workflow.workflow.forEach((process) => {
        if (process.included) {
          ret.push(process)
        }
      })
      return ret
    },

    sortedMessageList: function () {
      return this.messageList.sort(function (a, b) {
        return new Date(b.createdStr) - new Date(a.createdStr)
      })
    },

    /**
     * Computed Haulage export Information
     */
    haulage_export_info: {
      // getter
      get() {
        if (this.shipment == null) {
          return null
        }

        let tmp = {
          haulage_export: this.shipment.haulage_export,
        }
        return tmp
      },
    },

    /**
     * Computed Haulage import Information
     */
    haulage_import_info: {
      // getter
      get() {
        if (this.shipment == null) {
          return null
        }

        let tmp = {
          haulage_import: this.shipment.haulage_import,
        }
        return tmp
      },
    },

    /**
     * Computed Transport export Information
     */
    transport_export_info: {
      // getter
      get() {
        if (this.shipment == null) {
          return null
        }

        let tmp = {
          transport_export: this.shipment.transport_export,
        }
        return tmp
      },
    },

    /**
     * Computed Transport import Information
     */
    transport_import_info: {
      // getter
      get() {
        if (this.shipment == null) {
          return null
        }

        let tmp = {
          transport_import: this.shipment.transport_import,
        }
        return tmp
      },
    },

    /**
     * Computed Shipment Schedule Override Information
     */
    shipment_schedule_info: {
      // getter
      get() {
        if (this.shipment == null) {
          return null
        }

        let tmp = {
          shipment_schedule: this.shipment.quotation.shipment_schedule,
        }
        return tmp
      },
    },
  },
}
</script>

<style scoped>
hr.hr-line {
  border: 1.5px solid grey;
  width: 100%;
}

.v-input.v-text-field.modified-text-field {
  margin-top: 0px;
  padding-top: 0px;
  border: 0px !important;
  border-radius: 5px;
}

.v-alert {
  z-index: 1;
}

.v-application .caption-line-2 {
  /* font-size: 0.55rem !important; */
  font-size: 10px !important;
  letter-spacing: 0.025rem !important;
}
</style>
